<template>
    <div class="card box-shadow-high bg-white d-flex flex-row p-3 align-items-center mb-3" >
        <div class="mr-auto">
            <h3 class="font-weight-light m-0">{{lead.name}}</h3>
            <div class="small text-grey">
                {{(lead.type || 'Moving') | humanize}} {{lead.serviceDate | formatJobDateShort}}
                •
                Submitted {{lead.createdAtUtc | formatDateShort}}
            </div>
        </div>
        <div :class="this.statusClass" class="rounded bg-secondary p-2">{{this.statusLabel}}</div>
    </div>
</template>

<script>
export default {
  name: 'app-lead-card',
  props: {
    lead: {},
  },
  data() {
    return {
      statusClass: '',
      statusLabel: '',
    };
  },
  mounted() {
    switch (this.lead.status) {
      case 'NewLead':
        this.statusClass = 'text-primary';
        this.statusLabel = 'New';
        break;
      case 'LeadInProgress':
      case 'Opportunity':
        this.statusClass = 'text-primary';
        this.statusLabel = 'Pending';
        break;
      case 'Booked':
      case 'Completed':
      case 'Closed':
        this.statusClass = 'text-success';
        this.statusLabel = 'Won';
        break;
      default:
        this.statusClass = 'text-warning';
        this.statusLabel = 'Lost';
    }
  },
};
</script>
